/**
 * Created: 2026-04-22
 * Initial commit: Centralize event-related UI label maps (feat/event/mr-24)
 *
 * Central label and color maps for event-related enums used across the frontend.
 */

import { EventStatus, GameFormat } from '../gql/graphql'

export const GAME_FORMAT_CHIP: Record<
  GameFormat,
  { label: string; color: 'primary' | 'secondary' }
> = {
  [GameFormat.Freeplay]: { label: '畅打', color: 'secondary' },
  [GameFormat.Singles]: { label: '比赛', color: 'primary' },
  [GameFormat.Doubles]: { label: '比赛', color: 'primary' },
  [GameFormat.RotatingDoubles]: { label: '比赛', color: 'primary' },
}

export const EVENT_STATUS_LABEL: Record<EventStatus, string> = {
  [EventStatus.Created]: '报名中',
  [EventStatus.Started]: '进行中',
  [EventStatus.Completed]: '已完成',
  [EventStatus.Cancelled]: '已取消',
  [EventStatus.Aborted]: '已中止',
}

export const EVENT_STATUS_COLOR: Record<
  EventStatus,
  'default' | 'primary' | 'success' | 'error' | 'warning'
> = {
  [EventStatus.Created]: 'primary',
  [EventStatus.Started]: 'warning',
  [EventStatus.Completed]: 'success',
  [EventStatus.Cancelled]: 'error',
  [EventStatus.Aborted]: 'error',
}

export const GAME_FORMAT_LABEL: Record<GameFormat, string> = {
  [GameFormat.Freeplay]: '畅打',
  [GameFormat.Singles]: '单打',
  [GameFormat.Doubles]: '双打',
  [GameFormat.RotatingDoubles]: '循环双打',
}
